import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-alert-icon"
}
const _hoisted_2 = { class: "m-alert-content" }

import { ColorVariants } from "@medapro-types/common/common";
import Icon from "./Icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Alert',
  props: {
    variant: { default: "info" },
    show: { type: Boolean },
    dismissible: { type: Boolean },
    withIcon: { type: Boolean }
  },
  emits: ["dismissed"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const getIcon = () => {
  switch (props.variant) {
    case "warning":
      return "Warning1";
    case "danger":
      return "WatcherWarning";
    case "success":
      return "CheckCircle";
    default:
      return "Info";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_b_alert = _resolveComponent("b-alert")!

  return (_openBlock(), _createBlock(_component_b_alert, {
    class: "m-alert",
    show: _ctx.show,
    onDismissed: _cache[1] || (_cache[1] = ($event: any) => (emits('dismissed', $event))),
    variant: _ctx.variant
  }, {
    default: _withCtx(() => [
      (_ctx.withIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(Icon, {
              icon: getIcon(),
              size: "16px"
            }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.dismissible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "m-alert-close-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('dismissed', $event)))
          }, [
            _createVNode(Icon, {
              icon: "Close",
              size: "16px"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["show", "variant"]))
}
}

})